
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wedding-ideas-blog/[post]",
      function () {
        return require("private-next-pages/wedding-ideas-blog/[post].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wedding-ideas-blog/[post]"])
      });
    }
  